import { Avatar, Checkbox, Meter, RoleBadge, StatusPill } from "./MemberParts";
import { IconDots } from "./icons";
import { relativeTime, type MemberVM } from "./memberModel";

type Props = {
  m: MemberVM;
  selected: boolean;
  onSelect: (id: number) => void;
  onOpen: (id: number) => void;
  onMenu: (id: number, anchor: HTMLElement) => void;
};

/** One dense table row in the Table layout. The whole row opens the sheet. */
export function MemberRow({ m, selected, onSelect, onOpen, onMenu }: Props) {
  return (
    <div
      className={`urow ubody-row${selected ? " sel" : ""}`}
      onClick={() => onOpen(m.id)}
    >
      <div className="ucell-check">
        <Checkbox on={selected} onClick={() => onSelect(m.id)} label={`Select ${m.name}`} />
      </div>

      <div className="uident">
        <Avatar m={m} />
        <div className="uident-body">
          <div className="uident-name">
            {m.name}
            {m.you && <span className="you-tag">you</span>}
          </div>
          <div className="uident-email">{m.email}</div>
        </div>
      </div>

      <div>
        <RoleBadge role={m.role} />
      </div>

      <div className="ucell-spend">
        {m.status === "pending" ? (
          <StatusPill status="pending" />
        ) : (
          <Meter spentCents={m.spentCents} capCents={m.monthlyCapCents} inline />
        )}
      </div>

      <div className="ucell-active">
        <span className="ulast">{relativeTime(m.lastLoginAt)}</span>
      </div>

      <div>
        <button
          className="kebab"
          aria-label={`Actions for ${m.name}`}
          onClick={(e) => {
            e.stopPropagation();
            onMenu(m.id, e.currentTarget);
          }}
        >
          <IconDots />
        </button>
      </div>
    </div>
  );
}
